import React, { useEffect, useState } from 'react'
import { Button, Spinner, Row, Col, Form, Badge } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RequiredLabel } from '../utils/validators';
import { getSubConceptsById, updateSubConcepts, activateSubConcept, getConcepts } from '../services/Concepts';

function EditSubConcept() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const [name, setName] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [originalIsActive, setOriginalIsActive] = useState(true);

  // CONCEPTOS
  const [concepts, setConcepts] = useState([]);
  const [conceptId, setConceptId] = useState('');

  const navigate = useNavigate();
  const redirectBack = () => navigate(`/subconcepts`);

  useEffect(() => {
    (async () => {
      const list = await getConcepts();
      setConcepts((list || []).filter(x => x.isActive));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const c = await getSubConceptsById(id);
        if (!c) {
          toast.error('No se pudo cargar el subconcepto');
          return;
        }
        setName(c.name || '');
        setIsActive(!!c.isActive);
        setOriginalIsActive(!!c.isActive);
        setConceptId(c.concept_id || '');
      } catch (e) {
        toast.error('No se pudo cargar el subconcepto');
      } finally {
        setIsLoading(false);
      }
    })();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return toast.warn('El nombre es requerido');

    try {
      setIsSaving(true);

      // 1) actualizar texto
      await updateSubConcepts(id, { name, concept_id: Number(conceptId) });

      // 2) si cambió el estatus, actualizarlo
      if (isActive !== originalIsActive) {
        await activateSubConcept(id, isActive);
      }

      toast.success('Subconcepto actualizado');
      navigate('/subconcepts');
    } catch (err) {
      console.error(err);
      toast.error('No se pudo actualizar el subconcepto');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formConceptName" className="mb-3">
            <Form.Label as={RequiredLabel} required>Nombre:</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={350}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label as={RequiredLabel} required>Concepto:</Form.Label>
            <Form.Select value={conceptId} onChange={(e) => setConceptId(e.target.value)}>
              <option value="">Selecciona...</option>
              {concepts.map(c => (
                <option key={c.id} value={c.id}>{c.description}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="formConceptActive" className="mb-3">
            <Form.Check
              type="switch"
              id="concept-active-switch"
              label={isActive ? 'Activo' : 'Inactivo'}
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />
          </Form.Group>

          <Row>
            <Col xl={12} className='text-center'>
              <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} disabled={isSaving}>
                Cancelar o regresar
              </Button>
              <Button className='m-3' variant="primary" type="submit" disabled={isSaving}>
                {isSaving ? 'Guardando...' : 'Guardar cambios'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <ToastContainer />
    </div>
  );
}

export default EditSubConcept;